// extracted by mini-css-extract-plugin
module.exports = {"Row":"MovieRow_Row__2-kU0","MoviesRow":"MovieRow_MoviesRow__2XqNM"};